import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BasketMetaService_GetPageMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/meta/service.grpc.lazy';
import {ensure404Page} from '../../../shared-deprecated/metaUtils';
import {useEnsureRedirectData} from '../../../shared-deprecated/useEnsureRedirectData';

export const useBasketPageMetaData = () => {
  const ensureRedirectData = useEnsureRedirectData();
  return useGrpcRequest(
    BasketMetaService_GetPageMetaDataLazy,
    {},
    {
      validateData: ensureRedirectData,
      validateError: ensure404Page,
      retry: false,
    },
  );
};
